exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".progressText {\n    grid-area: progressText;\n    display: grid;\n    justify-items: center;\n    align-items: center;\n    grid-template-rows: 1fr;\n    grid-template-columns: auto auto auto;\n    padding: 5px;\n}", ""]);

